import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import EnhanceRoute from "src/components/root/routeHelpers/EnhanceRoute";
import config from "src/config";
import { lazyImport } from "src/lib";

const Login = lazy(() => lazyImport(() => import("src/apps/shared/Login")));
const ForgotPassword = lazy(() => lazyImport(() => import("src/apps/shared/ForgotPassword")));
const ResetPassword = lazy(() => lazyImport(() => import("src/apps/shared/ResetPassword")));
const Register = lazy(() => lazyImport(() => import("src/apps/shared/Register")));
const SignUp = lazy(() => lazyImport(() => import("src/apps/shared/SignUp")));
const ClaimAccount = lazy(() => lazyImport(() => import("src/apps/shared/ClaimAccount")));
const Onboarding = lazy(() => lazyImport(() => import("src/apps/shared/Onboarding")));

export function SharedRoutes() {
  return [
    <Route
      key="/register"
      path="/register"
      element={
        <EnhanceRoute title={`Register your account | ${config.brandName}`}>
          <Register />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/sign-up"
      path="/sign-up"
      element={
        <EnhanceRoute title={`Create your account | ${config.brandName}`}>
          <SignUp />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/claim-account"
      path="/claim-account"
      element={
        <EnhanceRoute title={`Claim your account | ${config.brandName}`}>
          <ClaimAccount />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/onboarding"
      path="/onboarding"
      element={
        <EnhanceRoute title={`Welcome | ${config.brandName}`}>
          <Onboarding />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/login"
      path="/login"
      element={
        <EnhanceRoute title={`Login to your account | ${config.brandName}`}>
          <Login />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/forgot-password"
      path="/forgot-password"
      element={
        <EnhanceRoute title={`Forgot your password? | ${config.brandName}`}>
          <ForgotPassword />
        </EnhanceRoute>
      }
    />,
    <Route
      key="/reset-password"
      path="/reset-password"
      element={
        <EnhanceRoute title={`Password reset | ${config.brandName}`}>
          <ResetPassword />
        </EnhanceRoute>
      }
    />,
    // portfolio/analytics is a deprecated route - should just be the root now
    <Route key="/portfolio/analytics" path="/portfolio/analytics" element={<Navigate replace to="/" />} />,
  ];
}
